import {AfterViewInit, Component, OnInit} from '@angular/core';
import {CommonService} from '../../../../services/common.service';
import {LocalStorageService} from '../../../../services/local-storage.service';

@Component({
    selector: 'app-mobile-history',
    templateUrl: './mobile-history.component.html',
    styleUrls: ['./mobile-history.component.scss']
})
export class MobileHistoryComponent implements OnInit, AfterViewInit {
    user: any;
    children: any[] = [];

    constructor(private localStorageService: LocalStorageService,
                private commonService: CommonService) {
        this.user = JSON.parse(this.localStorageService.get('user'));
    }

    ngOnInit(): void {
    }

    async ngAfterViewInit() {
        await this.initializeChildren();
    }

    async initializeChildren() {
        try {
            const childrenRequest = await this.commonService.getList(`children?parentId=${this.user.id}`);
            this.children = childrenRequest.object;
            let extraInfo;
            const hasExternalClasses = localStorage.getItem('externalClasses');
            if (hasExternalClasses) {
                const extraInfoRequest = await this.commonService.getList(`children/external?parentId=${this.user.id}`);
                extraInfo = extraInfoRequest.object;
            }
            for (const child of this.children) {
                child.notifications = [];
                child.affirmations = [];
                child.announcements = [];
                if (extraInfo && extraInfo.length > 0) {
                    const currentChild = extraInfo.find(c => c.id === child.id);
                    if (currentChild) {
                        child.SchoolUnit = currentChild.SchoolUnit;
                        child.SchoolLevel = currentChild.SchoolLevel;
                        child.Class = currentChild.Class;
                        child.Class_Short = currentChild.Class_Short;
                    }
                }
            }
        } catch (e) {
            throw e.message;
        } finally {

        }
    }
}
